import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { _t } from '../../../core/services/translation/helpers/preview-text.function';

@Component({
  selector: 'app-not-found-page',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './not-found-page.component.html',
  styleUrl: './not-found-page.component.scss',
})
export class NotFoundPageComponent {
  protected readonly _t = _t;
}
